document.addEventListener('DOMContentLoaded', function() {
  const calculators = document.querySelectorAll('.coverage-calculator');

  calculators.forEach(container => {
    // 1. Read Data Attributes (Passed from Liquid)
    let coverageRate = parseFloat(container.dataset.coverageRate);
    let outputUnit = container.dataset.unit || "Litres";
    let density = 1;

    // Select Elements
    const unitSelect = container.querySelector('.calc-unit');
    const methodSelect = container.querySelector('.calc-method');
    const areaGroup = container.querySelector('[data-type="area"]');
    const dimGroup = container.querySelector('[data-type="dimensions"]');
    const btn = container.querySelector('.calc-btn');
    const resultBox = container.querySelector('.calc-result');
    const outputText = container.querySelector('.calc-output');
    const unitLabels = container.querySelectorAll('.unit-label');
    const lenLabels = container.querySelectorAll('.unit-len');

    let isMetric = true;

    // Unit Toggle Logic
    unitSelect.addEventListener('change', (e) => {
      isMetric = e.target.value === 'metric';
      unitLabels.forEach(el => el.textContent = isMetric ? 'm²' : 'ft²');
      lenLabels.forEach(el => el.textContent = isMetric ? 'm' : 'ft');
    });

    // Method Toggle Logic
    methodSelect.addEventListener('change', (e) => {
      if(e.target.value === 'area') {
        areaGroup.classList.remove('hidden');
        dimGroup.classList.add('hidden');
      } else {
        areaGroup.classList.add('hidden');
        dimGroup.classList.remove('hidden');
      }
    });

    // Calculation Logic
    btn.addEventListener('click', () => {
      const method = methodSelect.value;
      let area = 0;

      if(method === 'area') {
        area = parseFloat(container.querySelector('.calc-area').value) || 0;
      } else {
        const w = parseFloat(container.querySelector('.calc-width').value) || 0;
        const h = parseFloat(container.querySelector('.calc-height').value) || 0;
        area = w * h;
      }

      if(area <= 0) {
        outputText.textContent = "Enter valid dimensions";
        resultBox.classList.remove('hidden');
        return;
      }

      // Convert Imperial to Metric if needed (1 sq ft = 0.092903 sq m)
      let metricArea = isMetric ? area : (area * 0.092903);
      const coats = parseInt(container.querySelector('.calc-coats').value) || 2;
      
      let requiredVolume = (metricArea * coats) / coverageRate;

      if(outputUnit === "KG") { requiredVolume = requiredVolume * density; }
      
      let displayValue = Math.ceil(requiredVolume * 10) / 10;
      outputText.textContent = `${displayValue} ${outputUnit}`;
      resultBox.classList.remove('hidden');
    });
  });
});